var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeView(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.08 7.66674C14.6534 6.92674 12.3067 3.21341 8.32003 3.33341C4.63337 3.42674 2.50004 6.66674 1.92004 7.66674C1.80095 7.87301 1.80095 8.12714 1.92004 8.33341C2.34004 9.06008 4.5867 12.6667 8.51337 12.6667H8.68003C12.3667 12.5734 14.5067 9.33341 15.08 8.33341C15.1991 8.12714 15.1991 7.87301 15.08 7.66674ZM8.50004 10.3334C7.21137 10.3334 6.1667 9.28874 6.1667 8.00008C6.1667 6.71141 7.21137 5.66674 8.50004 5.66674C9.7887 5.66674 10.8334 6.71141 10.8334 8.00008C10.8334 9.28874 9.7887 10.3334 8.50004 10.3334ZM8.50004 9.00008C9.05232 9.00008 9.50004 8.55236 9.50004 8.00008C9.50004 7.44779 9.05232 7.00008 8.50004 7.00008C7.94775 7.00008 7.50004 7.44779 7.50004 8.00008C7.50004 8.55236 7.94775 9.00008 8.50004 9.00008Z",
    fill: "#232C34"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeView);
export default __webpack_public_path__ + "static/media/eyeView.1b8c299d247d2ac68e4689a1e16ffec2.svg";
export { ForwardRef as ReactComponent };